module.exports = __webpack_public_path__ + "static/media/testimonial_bg.e2789b58.png";